


export enum reportType {
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}